import React from "react"
import Utils from "../../utilities/Utils";
import {FormSectionElements} from "src/entities/formTemplateDataType";

const HtmlToReactParser = require("html-to-react").Parser;

interface Props {
    errorMsgList;
    isEng: boolean;
    fromAPI?: boolean;
}

export class ErrorAlertsComponent extends React.Component<Props> {
    HtmlToReactParser = require('html-to-react').Parser;
    divRef: React.RefObject<HTMLDivElement>;

    static defaultProps = {
        fromAPI: false
    };

    constructor(props: Props) {
        super(props);
        this.divRef = React.createRef();
    }

    generateHtmlString = () => {
        const basePath = window.location.pathname;
        const hash = window.location.hash; // "#/subpath/page"
        const fullPath = `${basePath}${hash}`;
        
        const htmlToReactParser = new this.HtmlToReactParser();

        let errorMsgList = this.props.errorMsgList;

        if (errorMsgList == null || errorMsgList?.filter(p => p.Visible).length == 0) return null;

        let html = [];
      
        let errorMsgBulletPointHtml = [];

        const handleErrorLinkClick = (fieldName: string, event: React.MouseEvent) => {
            event.preventDefault();

            if (!fieldName) return;

            const escaped = CSS.escape(fieldName);
            let targetElement: HTMLElement | null =
                document.querySelector(`input[name="${escaped}"]`) ||
                document.querySelector(`select[id="${escaped}"]`) ||
                document.querySelector(`input[id="${escaped}"]`) ||
                document.querySelector(`textarea[id="${escaped}"]`) ||
                document.querySelector(`button[id="${escaped}"]`) ||
                document.querySelector(`fieldset[id="${escaped}"]`) ||
                document.getElementById(fieldName);

            if (!targetElement) {
                // Fallback: find label that points to this field and scroll to it
                const label = document.querySelector(`label[for="${escaped}"]`) as HTMLElement;
                if (label) {
                    label.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    label.focus();
                    return;
                }
                return;
            }

            // For invisible inputs (checkbox/radio styled with opacity:0), scroll to the visible wrapper instead
            const closestItem = targetElement.closest('.ontario-checkboxes__item, .ontario-radios__item, .ontario-checkboxes, .ontario-radios, .ontario-fieldset') as HTMLElement;
            const scrollTarget = closestItem || targetElement;

            scrollTarget.scrollIntoView({ behavior: 'smooth', block: 'center' });
            setTimeout(() => {
                targetElement!.focus();
            }, 300);
        };
        let message

        errorMsgList.filter(p => p.Visible && !p.Disabled).forEach((field: FormSectionElements, index: number) => {
            if(this.props.fromAPI && field.ErrorMessage) {
                message = this.props.isEng ? field.ErrorMessage : field.ErrorMessageFRA;
            } 
            else {
                if (!Utils.hasEmptyObject(field?.Value) && field?.enableCustomRichTextErrorMessage &&
                    (this.props.isEng ? field.ErrorMessageRichText : field.ErrorMessageRichTextFRA)) {
                    message = htmlToReactParser.parse(this.props.isEng
                        ? field.ErrorMessageRichText
                        : field.ErrorMessageRichTextFRA);
                } else {
                message = Utils.hasEmptyObject(field?.Value)
                    ? (this.props.isEng ? Utils.safeReplace(field.EmptyErrorMessage, '{0}', field.ENUTitle)
                        : Utils.safeReplace(field.EmptyErrorMessageFRA, '{0}', field.FRATitle))
                    : (this.props.isEng ? Utils.safeReplace(field.ErrorMessage, '{0}', field.ENUTitle)
                        : Utils.safeReplace(field.ErrorMessageFRA, '{0}', field.FRATitle))

                if(field.Datatype === "File" && Utils.hasEmptyObject(field?.Value) && field.isContinueFile){
                    message=this.props.isEng?Utils.safeReplace(field.EmptyErrorMessage, '{0}', field.ENUTitle):Utils.safeReplace(field.EmptyErrorMessageFRA, '{0}', field.FRATitle);
                }else if(field.Datatype === "File" && Utils.hasEmptyObject(field?.Value) && !field.isContinueFile){
                    message=this.props.isEng?Utils.safeReplace(field.ErrorMessage, '{0}', field.ENUTitle):Utils.safeReplace(field.ErrorMessageFRA, '{0}', field.FRATitle);
                }

                }
            }
            if (message && !field.Valid) {
                if (this.props.fromAPI) {
                    errorMsgBulletPointHtml.push(
                        <p key={"fromAPI"}>
                            {message}
                        </p>
                    );
                } else {
                    errorMsgBulletPointHtml.push(
                        <li key={"error_" + field.Datatype + "_" + index}>
                            <a
                                href="#"
                                onClick={(e) => handleErrorLinkClick(field.LoadBindName, e)}
                                style={{ whiteSpace: 'pre-line' }}
                            >
                                {message}
                            </a>
                            {/* <span style={{color: '#d81a21'}}>{message}</span> */}
                        </li>
                    );
                }

            }
        });

        
      
        if (errorMsgBulletPointHtml.length) {
            html.push(
                <div ref={this.divRef} className="ontario-alert ontario-alert--error callout-max-width" role="alert" tabIndex={-1} id="error-container"  key={"error_alert_box" }>
                    <div className="ontario-alert__header">
                        <div className="ontario-alert__header-icon">
                            <svg className="ontario-icon" viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" fill="#cd0000" />
                                <path d="M11 17h2v-2h-2v2zm0-4h2V7h-2v6z" fill="#fff" />
                                <use href="#ontario-icon-alert-error"></use>
                            </svg>
                        </div>
                        <h2 className="ontario-alert__header-title ontario-h4">{this.props.isEng ? "There is a problem" : "Il y a un problème"}</h2>
                    </div>
                    <div className="ontario-alert__body">
                        <p>{this.props.isEng ? "Errors were found on this page" : "Des erreurs ont été trouvées sur cette page"}</p>
                        <ul>
                            {errorMsgBulletPointHtml}
                        </ul>
                    </div>
                </div>
            );
        }
        return html;
    }

    focus() {
        this.divRef.current?.focus();
    }

    render() {
        return (
            this.generateHtmlString()
        )
    }
}
